module.exports = __webpack_public_path__ + "static/media/sumaAsegurada.d29da937.svg";